// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gj7_F5sSamVOlsoqI_Zv {
  --progress-item-border: 1.5px;
  position: relative;
  height: 12px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .gj7_F5sSamVOlsoqI_Zv {
    --progress-item-border: 1px;
    height: 8px;
  }
}
[data-variant='card'].gj7_F5sSamVOlsoqI_Zv {
  background: #0a1a0f;
  border-style: solid;
  border-color: #243827;
  border-width: var(--progress-item-border) 0 var(--progress-item-border) 0;
}
[data-variant='card'] .n2gSnWPbcLnX8vJNosTY {
  background: var(--segment-fill-background, linear-gradient(90deg, var(--segment-gradient-start), var(--segment-gradient-end)));
  border-style: solid;
  border-width: var(--progress-item-border) 0 var(--progress-item-border) var(--progress-item-border);
  height: 100%;
  position: relative;
}
[data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-unlocked='true'] {
  border-color: #00570D;
  box-shadow: 0 0 20px 0 rgba(60, 255, 0, 0.2);
}
[data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-unlocked='true'][data-is-current='true'] {
  border-color: #574F00;
}
[data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-unlocked='false'] {
  border-color: #243827;
  box-shadow: 0 0 30px 0 rgba(60, 255, 0, 0.2);
}
/* More than one camapaign */
[data-has-many='true'] [data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-current='true']:after {
  height: 21px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-has-many='true'] [data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-current='true']:after {
    height: 15px;
    width: 1px;
  }
}
[data-has-many='true'] [data-variant='card'] .TWF1cYwFuFtufOYp_nbr {
  top: -34px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-has-many='true'] [data-variant='card'] .TWF1cYwFuFtufOYp_nbr {
    top: -25px;
  }
}
[data-variant='winnings-tab'].gj7_F5sSamVOlsoqI_Zv {
  border: var(--progress-item-border) solid #4F4403;
  border-radius: 7.5px;
  position: relative;
  width: var(--progress-item-width, 102px);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-variant='winnings-tab'].gj7_F5sSamVOlsoqI_Zv {
    width: var(--progress-item-width, 68px);
  }
}
[data-variant='winnings-tab'] .n2gSnWPbcLnX8vJNosTY {
  background: #FFDF1A;
  box-shadow: 0 0 6px 0 rgba(255, 223, 26, 0.5);
  border-radius: 7.5px 0 0 7.5px;
  border: var(--progress-item-border) solid #4F4403;
  height: 12px;
  position: absolute;
  top: calc(-1 * var(--progress-item-border));
  left: calc(-1 * var(--progress-item-border));
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-variant='winnings-tab'] .n2gSnWPbcLnX8vJNosTY {
    height: 8px;
  }
}
[data-variant='winnings-tab'] .n2gSnWPbcLnX8vJNosTY[data-percent='100'] {
  border-radius: 7.5px;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/RebateProgressItem/RebateProgressItem.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,2BAA2B;IAC3B,WAAW;EACb;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,yEAAyE;AAC3E;AACA;EACE,8HAA8H;EAC9H,mBAAmB;EACnB,mGAAmG;EACnG,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;AACA,4BAA4B;AAC5B;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,iDAAiD;EACjD,oBAAoB;EACpB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE;IACE,uCAAuC;EACzC;AACF;AACA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,8BAA8B;EAC9B,iDAAiD;EACjD,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,oBAAoB;AACtB","sourcesContent":[".progressItemContainer {\n  --progress-item-border: 1.5px;\n  position: relative;\n  height: 12px;\n}\n@media (--campaign-mobile) {\n  .progressItemContainer {\n    --progress-item-border: 1px;\n    height: 8px;\n  }\n}\n[data-variant='card'].progressItemContainer {\n  background: #0a1a0f;\n  border-style: solid;\n  border-color: #243827;\n  border-width: var(--progress-item-border) 0 var(--progress-item-border) 0;\n}\n[data-variant='card'] .progressItemFill {\n  background: var(--segment-fill-background, linear-gradient(90deg, var(--segment-gradient-start), var(--segment-gradient-end)));\n  border-style: solid;\n  border-width: var(--progress-item-border) 0 var(--progress-item-border) var(--progress-item-border);\n  height: 100%;\n  position: relative;\n}\n[data-variant='card'] .progressItemFill[data-is-unlocked='true'] {\n  border-color: #00570D;\n  box-shadow: 0 0 20px 0 rgba(60, 255, 0, 0.2);\n}\n[data-variant='card'] .progressItemFill[data-is-unlocked='true'][data-is-current='true'] {\n  border-color: #574F00;\n}\n[data-variant='card'] .progressItemFill[data-is-unlocked='false'] {\n  border-color: #243827;\n  box-shadow: 0 0 30px 0 rgba(60, 255, 0, 0.2);\n}\n/* More than one camapaign */\n[data-has-many='true'] [data-variant='card'] .progressItemFill[data-is-current='true']:after {\n  height: 21px;\n}\n@media (--campaign-mobile) {\n  [data-has-many='true'] [data-variant='card'] .progressItemFill[data-is-current='true']:after {\n    height: 15px;\n    width: 1px;\n  }\n}\n[data-has-many='true'] [data-variant='card'] .totalWinTooltip {\n  top: -34px;\n}\n@media (--campaign-mobile) {\n  [data-has-many='true'] [data-variant='card'] .totalWinTooltip {\n    top: -25px;\n  }\n}\n[data-variant='winnings-tab'].progressItemContainer {\n  border: var(--progress-item-border) solid #4F4403;\n  border-radius: 7.5px;\n  position: relative;\n  width: var(--progress-item-width, 102px);\n}\n@media (--campaign-mobile) {\n  [data-variant='winnings-tab'].progressItemContainer {\n    width: var(--progress-item-width, 68px);\n  }\n}\n[data-variant='winnings-tab'] .progressItemFill {\n  background: #FFDF1A;\n  box-shadow: 0 0 6px 0 rgba(255, 223, 26, 0.5);\n  border-radius: 7.5px 0 0 7.5px;\n  border: var(--progress-item-border) solid #4F4403;\n  height: 12px;\n  position: absolute;\n  top: calc(-1 * var(--progress-item-border));\n  left: calc(-1 * var(--progress-item-border));\n}\n@media (--campaign-mobile) {\n  [data-variant='winnings-tab'] .progressItemFill {\n    height: 8px;\n  }\n}\n[data-variant='winnings-tab'] .progressItemFill[data-percent='100'] {\n  border-radius: 7.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressItemContainer": `gj7_F5sSamVOlsoqI_Zv`,
	"progressItemFill": `n2gSnWPbcLnX8vJNosTY`,
	"totalWinTooltip": `TWF1cYwFuFtufOYp_nbr`
};
export default ___CSS_LOADER_EXPORT___;
